import moment from 'moment';
import { ClientAPI } from '../API/client';
import { MailAPI } from '../API/mail';
import { unoTheme } from '../assets/styles/unoTheme';
import { roles } from '../components/utils/user';
import { getMonthName } from '../components/utils/utils';

const HTML_TO_LAUNCH_PORTFOLIO_MAIL = (month, year) => {
    return `
    
        <div style="width: 100%; height: 100%; border-radius: 10px;">
            <h3>Olha que notícia boa!</h3>
            <br/>
            <p>Sua carteira foi atualizada e já está disponível no <b style="color: ${unoTheme.mainColor}">UNO</b>.</p>
            <p>Agora, você poderá gerar um relatório mensal completo e ter acesso às principais informações dos investimentos referentes ao mês de <b>${getMonthName(month) + '/' + year}</b> :)</p>
            <br/>
            <a href='https://unoapp.com.br/' target='_blank' style="text-decoration: none; background-color: ${unoTheme.mainColor}; color: white; padding: 8px 12px; border-radius: 5px">Acesse o UNO</a>
            <br/>
            <br/>
            <p><b>#vamosjuntos</b></p>
            <br/>
        </div>            
        
    `
}

//Enviando email para os gestores das carteiras
//Retorna { success, sent, total, noManagers } para que a tela avise quando o envio falhar
export async function sendLaunchPortofolioEmail(clientId, month, year) {

    //Obtendo emails dos gestores ativos do cliente selecionado
    //As APIs lançam erro quando não há resposta do servidor (falha de rede), por isso os .catch
    const responseManagers = await ClientAPI.getAllUsersClientByRole(clientId, roles.manager.id).catch(() => ({ success: false }));
    if (!responseManagers.success) {
        return { success: false, sent: 0, total: 0, noManagers: false };
    }

    const managersEmails = responseManagers.body.rows
        .filter(manager => manager.active !== false && manager.email)
        .map(manager => manager.email);

    if (managersEmails.length === 0) {
        return { success: false, sent: 0, total: 0, noManagers: true };
    }

    const responses = await Promise.all(managersEmails.map(email =>
        MailAPI.sendGeneralEmail('[LEMA] RPPS: Sua carteira foi atualizada!', email, HTML_TO_LAUNCH_PORTFOLIO_MAIL(month, year))
            .catch(() => ({ success: false }))
    ));

    const sent = responses.filter(response => response.success).length;
    return { success: sent === managersEmails.length, sent, total: managersEmails.length, noManagers: false };

}